export default __webpack_public_path__ + "static/media/IMG-20240708-WA0021.39f506c2.jpg";